module.exports = __webpack_public_path__ + "static/media/42.fe27e59f.gif";